import { render, staticRenderFns } from "./EmployeeActivity.vue?vue&type=template&id=6a93b252"
import script from "./EmployeeActivity.vue?vue&type=script&lang=js"
export * from "./EmployeeActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a93b252')) {
      api.createRecord('6a93b252', component.options)
    } else {
      api.reload('6a93b252', component.options)
    }
    module.hot.accept("./EmployeeActivity.vue?vue&type=template&id=6a93b252", function () {
      api.rerender('6a93b252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/EmployeeActivity.vue"
export default component.exports